import * as React from 'react';
import { clsx } from 'clsx';
import { Checkbox } from '../../../../checkbox';
import styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const MultiSelectDesktopDropdownItem = /*#__PURE__*/React.forwardRef(function MultiSelectDesktopDropdownItem(_ref, forwardedRef) {
  let {
    value,
    label,
    description,
    name,
    focused,
    selected,
    dataTestId,
    onClick,
    onMouseMove
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ref: focused ? forwardedRef : undefined,
    className: clsx(styles['checkbox-wrapper'], focused && styles['focused']),
    onClick: onClick,
    onMouseMove: onMouseMove,
    role: "option",
    "aria-selected": selected ? 'true' : undefined,
    tabIndex: 0,
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(Checkbox, {
      name: name,
      value: value,
      checked: selected,
      label: label,
      description: description,
      tabIndex: -1,
      onClick: preventDefault
    })
  });
});
function preventDefault(event) {
  event.preventDefault();
}